// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"702":"d580c184","923":"ed8be631"}[chunkId] + ".chunk.css";
};